import React from 'react'
import { useFindReserveContext } from '../../contexts/find-reserve-context'
import { NewLineFormatter } from '../NewLineFormatter/NewLineFormatter'

export const PaymentPolicyInfo = () => {
  const { selectedAvailability } = useFindReserveContext()

  if (!selectedAvailability?.payment?.policy) {
    return null
  }

  return (
    <>
      <div className='text-secondary'>
        <NewLineFormatter text={selectedAvailability.payment.policy} />
      </div>
      <div className='border-b pt-4 mb-4' />
    </>
  )
}
